module.exports = __webpack_public_path__ + "media/photo/Group 255@2x-0268cf94.png";